import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AppContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <p className="text-forest-soft">Chargement...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
